import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

interface IProps {
    children: ReactNode;
}

const AuthLayout = ({ children }: IProps) => {
    return (
        <div className={"flex flex-col min-h-screen justify-between items-center text-neutral-100 px-2 bg-neutral-900 md:bg-neutral-800 text-center"}>
            <div className={"flex max-w-7xl px-1 w-full justify-center"}>
                <Link to={"/"}>
                    <LazyLoadImage
                        alt=""
                        className="object-cover auto min-h-full h-16 md:h-14 my-4"
                        effect="opacity"
                        src={`/images/logofull.png`}
                    />
                </Link>
                <span className={"min-w-24"} />
            </div>
            {children}
            <span className={"min-h-20"} />
        </div>
    );
};

export default AuthLayout;